import { render, staticRenderFns } from "./VacancyRecruitment.vue?vue&type=template&id=55e72fdd"
import script from "./VacancyRecruitment.vue?vue&type=script&lang=js"
export * from "./VacancyRecruitment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports